'use client';
import React from 'react';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { FormattedMessage } from 'react-intl';
import { ResourcesBlockArgs } from '@osmosis/shared/types/pages';

type Props = {
  resourcesObj: ResourcesBlockArgs;
};
/**
 * This is the references component for the answers page.
 */
const AnswerReferences = ({ resourcesObj }: Props) => {
  const { resources } = resourcesObj;
  return (
    <section className="p-5 font-sans text-gray-800 border border-gray-300 rounded-lg my-5">
      <header
        className="flex items-center mb-4"
        data-testid="answer-page-references-header"
      >
        <Icon icon={faGlobe} className="h-6 w-6 mr-2" />
        <h2 className="text-xl font-bold text-gray-800">
          <FormattedMessage
            id="references.Label"
            defaultMessage="References "
          />
        </h2>
      </header>
      <hr className="border-gray-300 mb-4" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {resources?.map((resource, index) => (
          <article
            key={`${resource.citation}`}
            className="p-2 col-span-1 md:col-span-2"
            data-testid={`answer-page-reference-citations`}
          >
            <span
              className="text-gray-800 w-full block"
              style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}
              dangerouslySetInnerHTML={{
                __html: resource.citation.replace(/<\/p>/g, '</p><br>'),
              }}
            />
          </article>
        ))}
      </div>
    </section>
  );
};

export default AnswerReferences;
